/**
 * Link-portal route — /link-portal
 *
 * Публичный (неаутентифицированный) роут: сюда приходят по ссылке из
 * приложения в CRM-портале, ещё не будучи залогиненными в Clerk. Гейт в
 * `__root.tsx` пропускает его вместе с /sign-in и /sign-up.
 */
import { createFileRoute } from '@tanstack/react-router';
import { LinkPortalScreen } from '@/features/auth/LinkPortalScreen';

export const Route = createFileRoute('/link-portal')({
  component: LinkPortalScreen,
});
